// src/pages/mairie/GestionTechniciens.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { config } from '../../config';

export default function GestionTechniciens() {
    const [techniciens, setTechniciens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        nom: '',
        prenom: '',
        telephone: '',
        mot_de_passe: '123456'
    });
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(null);

    const fetchTechniciens = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${config.apiBase}/mairie/list_techniciens.php`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) {
                setTechniciens(data.techniciens);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Erreur de chargement');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTechniciens();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.nom.trim() || !formData.prenom.trim() || !formData.telephone.trim()) {
            toast.error('Tous les champs sont obligatoires');
            return;
        }

        setSubmitting(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${config.apiBase}/mairie/create_technicien.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    nom: formData.nom,
                    prenom: formData.prenom,
                    telephone: formData.telephone,
                    mot_de_passe: formData.mot_de_passe || '123456'
                })
            });
            const data = await res.json();
            if (data.success) {
                toast.success(`Technicien créé ! Mot de passe: ${data.mot_de_passe_par_defaut}`);
                setFormData({ nom: '', prenom: '', telephone: '', mot_de_passe: '123456' });
                setShowForm(false);
                fetchTechniciens();
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Erreur');
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Supprimer ce technicien ?')) return;
        setDeleting(id);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${config.apiBase}/mairie/delete_technicien.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ id_utilisateur: id })
            });
            const data = await res.json();
            if (data.success) {
                toast.success('Technicien supprimé');
                fetchTechniciens();
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Erreur');
        } finally {
            setDeleting(null);
        }
    };

    const resetForm = () => {
        setFormData({ nom: '', prenom: '', telephone: '', mot_de_passe: '123456' });
        setShowForm(false);
    };

    return (
        <div className="max-w-4xl mx-auto p-6">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="text-2xl font-bold">👨‍💻 Gestion des techniciens</h1>
                    <p className="text-sm text-gray-500">Créez et gérez les comptes techniciens</p>
                </div>
                <button
                    onClick={() => setShowForm(!showForm)}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                >
                    {showForm ? '✕ Annuler' : '+ Nouveau technicien'}
                </button>
            </div>

            {showForm && (
                <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl shadow-lg border mb-6">
                    <h2 className="text-lg font-semibold mb-4">📝 Nouveau technicien</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                            <input
                                type="text"
                                value={formData.nom}
                                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Prénom *</label>
                            <input
                                type="text"
                                value={formData.prenom}
                                onChange={(e) => setFormData({ ...formData, prenom: e.target.value })}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone *</label>
                            <input
                                type="text"
                                value={formData.telephone}
                                onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                                placeholder="Ex: 90-12-3456"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
                            <input
                                type="text"
                                value={formData.mot_de_passe}
                                onChange={(e) => setFormData({ ...formData, mot_de_passe: e.target.value })}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                placeholder="123456 (par défaut)"
                            />
                            <p className="text-xs text-gray-400 mt-1">Par défaut: 123456</p>
                        </div>
                    </div>
                    <div className="mt-4 flex gap-2">
                        <button 
                            type="submit" 
                            disabled={submitting}
                            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                        >
                            {submitting ? 'Création...' : '➕ Créer le technicien'}
                        </button>
                        <button 
                            type="button" 
                            onClick={resetForm} 
                            className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-300 transition"
                        >
                            Annuler
                        </button>
                    </div>
                </form>
            )}

            {loading ? (
                <div className="flex items-center justify-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600"></div>
                </div>
            ) : techniciens.length === 0 ? (
                <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                    <div className="text-6xl mb-4">👨‍💻</div>
                    <p className="text-gray-500 text-lg">Aucun technicien enregistré</p>
                    <p className="text-sm text-gray-400">Cliquez sur "Nouveau technicien" pour en ajouter</p>
                </div>
            ) : (
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nom</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Prénom</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Téléphone</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Statut</th>
                                    <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Action</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {techniciens.map((t) => (
                                    <tr key={t.id_utilisateur} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-sm">{t.nom}</td>
                                        <td className="px-4 py-3 text-sm">{t.prenom}</td>
                                        <td className="px-4 py-3 text-sm">{t.telephone}</td>
                                        <td className="px-4 py-3 text-sm">
                                            <span className={`text-xs px-2 py-1 rounded-full ${
                                                t.statut === 'actif' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                                            }`}>
                                                {t.statut || 'actif'}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-center">
                                            <button
                                                onClick={() => handleDelete(t.id_utilisateur)}
                                                disabled={deleting === t.id_utilisateur}
                                                className="bg-red-50 text-red-600 px-3 py-1 rounded hover:bg-red-100 transition text-sm disabled:opacity-50"
                                            >
                                                {deleting === t.id_utilisateur ? '...' : '🗑️ Supprimer'}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {techniciens.length > 0 && (
                <div className="mt-4 text-sm text-gray-500">
                    Total: <strong>{techniciens.length}</strong> technicien(s)
                </div>
            )}
        </div>
    );
}